<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header p-2 text-center bg-primary text-white">
                    <h4>Monitoreo Proceso Comprobantes de Pago de Pensión</h4>
                </div>
                <div class="card-body">
                    <fieldset class="border p-2">
                        <legend class="w-auto">Filtro de Búsqueda</legend>
                        <form>
                            <div class="form-row">
                                <div class="col">
                                    <div class="form-group">
                                        <label for="Periodo">Periodo </label>
                                        <input type="number" id="period" class="form-control" v-model="period"
                                            placeholder="YYYYMM" @input="validatePeriod"
                                            :class="{ 'is-invalid': periodError }" />
                                        <div v-if="periodError" class="invalid-feedback"> {{ periodErrorMessage }}
                                        </div>
                                    </div>

                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label> RUT Cliente</label>
                                        <input type="text" id="customer-id" class="form-control" v-model="customerID"
                                            @input="formatRut('customerID')" :class="{ 'is-invalid': customerIDError }"
                                            placeholder="XXXXXXXX-X" />
                                        <div v-if="customerIDError" class="invalid-feedback">Rut inválido</div>
                                    </div>

                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label> RUT Beneficiario</label>
                                        <input type="text" id="beneficiary-id" class="form-control"
                                            v-model="beneficiaryID" @input="formatRut('beneficiaryID')"
                                            :class="{ 'is-invalid': beneficiaryIDError }" placeholder="XXXXXXXX-X" />
                                        <div v-if="beneficiaryIDError" class="invalid-feedback">Rut inválido</div>
                                    </div>

                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label> </label>
                                        <button type="button" class="btn btn-primary btn-block mt-2" @click="search"
                                            :disabled="isSearchDisabled">
                                            Buscar
                                        </button>

                                    </div>
                                    <div v-if="beneficiaryIDError" class="invalid-feedback">Invalid beneficiary ID
                                        format</div>
                                </div>
                            </div>
                        </form>
                    </fieldset>
                    <div class="d-flex justify-content-center align-items-center loader-wrapper" v-if="isLoader">
                        <div>
                            <div class="spinner-border text-dark"></div>
                        </div>
                    </div>

                    <div class="row" v-if="!isLoader">
                        <div class="col-md-9">
                            <div v-if="isVisibleResumen">


                                <fieldset class="border p-2">
                                    <legend class="w-auto">Resumen Procesamiento</legend>
                                    <!-- image  -->
                                    <div class="row">
                                        <div class="col-md-3"></div>
                                        <div class="col-md-9 mb-4">
                                            <img src="../assets/progress2.png" alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    <!-- progressbar -->
                                    <div class="scroll-container overflow-auto p-2">
                                        <!-- standard -->
                                        <div class="border px-5 py-3">
                                            <div v-if="isStandardProcess">
                                                <div class="row" v-for="summary in ProcessingSummary"
                                                    v-bind:key="summary.fileName + '-' + summary.processId">
                                                    <div class="col-3 small">
                                                        {{ summary.fileName }}
                                                    </div>
                                                    <div class="col-9 progress mb-3 px-0 "
                                                        :style="isHighlighted(summary.processId, summary.fileName) ? { border: '3px solid #eeff00' } : { border: 'none' }">
                                                        <!-- csv 1 -->
                                                        <div class="col-md-4 px-0 mb-5">
                                                            <div class="progress reprocess-pb">
                                                                <div
                                                                    :class="[
                                                                            summary.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                            (summary.firstCSV && summary.firstCSV == 'Failed') ? 'bg-danger' : 'bg-success'
                                                                        ]"
                                                                    role="progressbar"
                                                                    :style="{ width: summary.firstCSV && summary.firstCSV !== 'Skipped' ? '100%' : '0%' }">
                                                                    <div class="mt-3 text-left pl-2">
                                                                        <p class="font-weight-bold">N° Comprobantes: {{
                                                                            new
                                                                            Intl.NumberFormat('es-CL').format(summary.numberOfReceipts)
                                                                            }}</p>
                                                                        <p class="font-weight-bold">N° Comprobantes con error: {{
                                                                            new
                                                                            Intl.NumberFormat('es-CL').format(summary.nonRenderedReceipts)
                                                                            }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Rendered Receipts Percentage -->
                                                        <div class="col-md-4 px-0">
                                                            <div class="progress reprocess-pb">
                                                                <div
                                                                    :class="[
                                                                            summary.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                            (summary.nonRenderedReceipts > 0) ? 'bg-danger' : 'bg-success'
                                                                        ]"
                                                                    role="progressbar"
                                                                    :style="{ width: `${summary.isCompleted ? 100 :summary.renderedReceiptsPercentage }%`, }">
                                                                    <div class="mt-3 pl-2">
                                                                        <p class="font-weight-bold text-left ">% de Avance : {{summary.isCompleted ? 100 :summary.renderedReceiptsPercentage  }}%</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- csv 2 -->
                                                        <div class="col-md-4 px-0 ">
                                                            <div class="progress reprocess-pb">
                                                                <div
                                                                    :class="[
                                                                            summary.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                            (summary.secondCSV && summary.secondCSV == 'Failed')|| summary.nonRenderedReceipts > 0 ? 'bg-danger' : 'bg-success'
                                                                        ]"
                                                                    role="progressbar"
                                                                    :style="{ width: summary.secondCSV && summary.secondCSV !== 'Skipped' ? '100%' : '0%' }">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="alert alert-danger mb-0" v-else>
                                                <strong>No se ha ejecutado un proceso estándar de renderizado para los
                                                    filtros seleccionados</strong>
                                            </div>
                                        </div>
                                        <!-- reprocess  -->
                                        <div class="card my-2">
                                            <div v-for="reprocessSummary in ReprocessingSummary"
                                                v-bind:key="reprocessSummary.processExecutionInfo.processId">
                                                <div class="card-header">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="user-details">
                                                                <p><strong>{{
                                                                        reprocessSummary.processExecutionInfo.processTimestamp
                                                                        }} - {{
                                                                        reprocessSummary.processExecutionInfo.username
                                                                        }}</strong></p>
                                                                <p>{{ reprocessSummary.processExecutionInfo.comment }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!-- Render options column -->
                                                        <div class="col-md-4">
                                                            <div class="render-options">
                                                                <p class="mb-0"><strong>Opciones
                                                                        Reprocesadas:</strong>
                                                                </p>
                                                                <ul class="list ">
                                                                    <li
                                                                        v-if="reprocessSummary.processExecutionInfo.actionFiltersRaw.generateFirstNotification">
                                                                        CSV Notificación fecha pago</li>
                                                                    <li
                                                                        v-if="reprocessSummary.processExecutionInfo.actionFiltersRaw.renderLink">
                                                                        Renderizado</li>
                                                                    <li
                                                                        v-if="reprocessSummary.processExecutionInfo.actionFiltersRaw.generateSecondtNotification">
                                                                        CSV Notificación comprobante pago</li>
                                                                    <li
                                                                        v-if="reprocessSummary.processExecutionInfo.actionFiltersRaw.loadBase64">
                                                                        Carga IPS</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p>
                                                                <strong class="ml-2">Periodo
                                                                    {{ period }} - ID Batch {{
                                                                    reprocessSummary.processExecutionInfo.batchId }}
                                                                </strong>
                                                            </p>
                                                        </div>


                                                    </div>
                                                </div>

                                                <div class="card-body px-5 py-3">
                                                    <div>
                                                        <div class="row"
                                                            v-for="reprocessData in reprocessSummary.fileExecutionInfo"
                                                            v-bind:key="reprocessData.processId + reprocessData.fileName">
                                                            <div class="col-md-3 small pl-0">
                                                                {{ reprocessData.fileName }}
                                                            </div>
                                                            <div class="col-md-9 progress mb-2 px-0"
                                                                :style="isHighlighted(reprocessData.processId, reprocessData.fileName) ? { border: '3px solid #eeff00' } : { border: 'none' }">
                                                            <!-- reprocess csv 1 -->
                                                                <div class="col-md-4 px-0">
                                                                    <div class="progress reprocess-pb">
                                                                        <div
                                                                            :class="[
                                                                                reprocessData.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                                (reprocessData.firstCSV && reprocessData.firstCSV == 'Failed') ? 'bg-danger' : 'bg-success'
                                                                            ]"
                                                                            role="progressbar"
                                                                            :style="{ width: (reprocessData.firstCSV && reprocessData.firstCSV !== 'Skipped')&& reprocessSummary.processExecutionInfo.actionFiltersRaw.generateFirstNotification ? '100%' : '0%' }">
                                                                            <div class="mt-3 text-left pl-2">
                                                                                <p class="font-weight-bold">N°
                                                                                    Comprobantes: {{
                                                                                        new
                                                                                    Intl.NumberFormat('es-CL').format(reprocessData.numberOfReceipts)
                                                                                    }}</p>
                                                                                <p class="font-weight-bold"> N° Comprobantes con error: {{
                                                                                    new
                                                                                    Intl.NumberFormat('es-CL').format(reprocessData.nonRenderedReceipts)
                                                                                    }}</p>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- reprocess render  -->
                                                                <div class="col-md-4 px-0 ">
                                                                    <div class="progress reprocess-pb ">
                                                                        <div
                                                                            :class="[
                                                                                reprocessData.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                                (reprocessData.nonRenderedReceipts > 0) ? 'bg-danger' : 'bg-success'
                                                                                ]"
                                                                            role="progressbar"
                                                                            :style="{ width: `${reprocessData.isCompleted &&
                                                                                    reprocessSummary.processExecutionInfo.actionFiltersRaw.renderLink ? 100 :
                                                                                    reprocessData.renderedReceiptsPercentage}%`, }">
                                                                            <div class="mt-3 pl-2 ">
                                                                                <p class="font-weight-bold text-left ">
                                                                                    % de Avance :
                                                                                {{ reprocessData.isCompleted ? 100 : reprocessData.renderedReceiptsPercentage}}%
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- reprocess csv 2 -->
                                                                <div class="col-md-4 px-0">
                                                                    <div class="progress reprocess-pb">
                                                                        <div
                                                                        :class="[
                                                                            reprocessData.isCompleted ? 'progress-bar' : 'progress-bar progress-bar-striped progress-bar-animated',
                                                                            (reprocessData.secondCSV && reprocessData.secondCSV == 'Failed')|| reprocessData.nonRenderedReceipts > 0 ? 'bg-danger' : 'bg-success'
                                                                            ]"
                                                                        role="progressbar"
                                                                        :style="{ width: (reprocessData.secondCSV && reprocessData.secondCSV !== 'Skipped')&& reprocessSummary.processExecutionInfo.actionFiltersRaw.generateSecondtNotification ? '100%' : '0%' }">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </fieldset>
                            </div>
                            <div class="alert alert-danger my-3" v-if="!isVisibleResumen && isDataLoaded">
                                <strong>No se ha ejecutado un proceso de renderizado para los filtros
                                    seleccionados</strong>
                            </div>
                            <div class="alert alert-danger my-3" v-if="!isDataLoaded">
                                <strong>No se han encontrados pagos ejecutados según los filtros
                                    seleccionados</strong>
                            </div>
                        </div>

                        <div class="col-md-3 pl-0">
                            <fieldset class="border p-2">
                                <legend class="w-auto">Resumen Periodo</legend>
                                <table class="table table-bordered table-sm small">
                                    <thead></thead>
                                    <tbody>

                                        <tr>
                                            <td>{{ periodSummaryHeading[0] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalDeComprobantes) }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>{{ periodSummaryHeading[1] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalRenderizados) }} |
                                                {{
                                                periodSummary.totalRenderizadosPercentage }}%</td>
                                        </tr>

                                        <tr>
                                            <td>{{ periodSummaryHeading[2] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalErrors) }} | {{
                                                periodSummary.totalErrorsPercentage }}% </td>
                                        </tr>

                                        <tr>
                                            <td>{{ periodSummaryHeading[3] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalPagosPGU) }} </td>
                                        </tr>

                                        <tr>
                                            <td>{{ periodSummaryHeading[4] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalDisponibleIPS) }} |
                                                {{
                                                periodSummary.totalDisponsibleIPSPercentage }}%</td>
                                        </tr>

                                        <tr>
                                            <td>{{ periodSummaryHeading[5] }}</td>
                                            <td>{{ new
                                                Intl.NumberFormat('es-CL').format(periodSummary.totalRegistrosDispuestosaMKT)
                                                }} | {{
                                                periodSummary.totalRenderizadosPercentage }}%</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </fieldset>
                            <div class="export-button">
                                <button type="button" class="btn btn-block btn-primary" @click="exportTodoCVS">
                                    Exportar Todo
                                </button>
                            </div>
                        </div>
                    </div>




                    <fieldset class="border p-2" v-if="isVisible">
                        <legend class="w-auto">Detalle del Proceso</legend>
                        <div class="d-md-flex justify-content-md-end" v-if="isProcessDetailsInfo">
                            <button type="button" class="btn btn-primary col-md-2 mb-2" @click="exportSelectionCVS">
                                Exportar selección
                            </button>
                        </div>
                        <div class="row">
                            <div class="col-md-12">

                                <table class="table table-bordered table-sm" v-if="isProcessDetailsInfo">
                                    <thead>
                                        <tr>
                                            <th>Periodo</th>
                                            <th>ID Liquidación</th>
                                            <th>Rut Cliente</th>
                                            <th>Rut Beneficiario</th>
                                            <th>IPS</th>
                                            <th>Disponible IPS</th>
                                            <th>Comprobante Genus</th>
                                            <th>Link IPS</th>
                                            <th>Link Renderizado</th>
                                            <th>Estado Notificación</th>
                                            <th>Causal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, index) in processDetailsInfo" :key="index">
                                            <td>
                                                {{ data.periodo }}
                                            </td>
                                            <td>
                                                {{ data.idLiquidacion }}
                                            </td>
                                            <td>
                                                {{ data.rutCliente }}
                                            </td>
                                            <td>
                                                {{ data.rutBeneficiario }}
                                            </td>
                                            <td>
                                                {{ data.pgu }}
                                            </td>
                                            <td>
                                                {{ data.disponibleIps }}
                                            </td>
                                            <!-- Comprobante Genus link-->
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="downloadGenusPDF(data.intInstruccion, parseInt(data.idLiquidacion), data.intSeqRegistro)">Link</button>
                                            </td>
                                            <!-- Link IPS -->
                                            <td>
                                                <div
                                                    v-if="data.pgu && data.pgu == 'SI' && data.disponibleIps && data.disponibleIps == 'SI'">
                                                    <button type="button" class="btn btn-link"
                                                        @click="viewAttachment(data.periodo, data.rutCliente)">Link</button>
                                                </div>
                                                <div v-else> --</div>
                                            </td>
                                            <!-- Link Renderizado -->
                                            <td>
                                                <div v-if="data.comprobanteGenus">
                                                    <button type="button" class="btn btn-link"
                                                        @click="downloadPDF(index)">
                                                        Link</button>
                                                </div>
                                                <div v-else>--</div>
                                            </td>
                                            <td>
                                                {{ data.estadoNotificacion }}

                                            </td>
                                            <td>
                                                {{ data.causal }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="alert alert-danger" v-else>
                                    <strong>Datos no encontrados.</strong>
                                </div>
                            </div>

                        </div>
                    </fieldset>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PdfRendringService from '../services/PdfRendringService'
import {
    CvsFileGenerator,
    downloadPDF,
    downloadCSV,
    CvsFileGeneratorBase64,
    CurrentPeriod,
    validatePeriodData,
    formatRutData,
    validateRUTData
} from '../services/common'
import Vue from 'vue' // in Vue 2

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
export default {
    name: "Monitoring",
    props: {},
    components: {},
    data() {
        return {
            isLoader: false,
            configthis: false,
            userId: "",
            userName: "",
            token: "",
            period: '', // Period input value
            customerID: '', // Customer ID (RUT) input value
            beneficiaryID: '', // Beneficiary ID (RUT) input value
            periodError: false, // Period input error flag
            customerIDError: false, // Customer ID (RUT) input error flag
            beneficiaryIDError: false, // Beneficiary ID (RUT) input error flag
            isVisible: false,
            isVisibleResumen: false,
            isStandardProcess: false,
            isPreviousResult: false,
            processDetails: [],
            getByPeriodResponse: [],
            ProcessingSummary: [],
            ReprocessingSummary: [], //reprocesssummary
            ProcessDetail: [],
            FileList: [],
            linkIpsdata: '',
            periodErrorMessage: '', // Period input error message
            periodSummaryHeading: ['Total de Comprobantes', 'Total Renderizados', 'Total Finalizados con error', 'Total Pagos IPS', 'Total Disponible IPS', 'Total Registros dispuestos a MKT'],
            periodSummary: [],
            processDetailsInfo: [],
            isProcessDetailsInfo: false,
            success: null,
            rutFileName: [],
            isDataLoaded: true,
            setCurrentPeriodDate: false
        };
    },

    computed: {
        isSearchDisabled() {
            return this.period.trim() === "";
        }
    },
    mounted() {
        this.userId = this.$route.query.idusuario;
        this.userName = this.$route.query.nombre;
        this.clientId = this.$route.query.clientid;
        this.clientSecret = this.$route.query.clientsecret;
        this.getToken();
        this.loadCurrentPeriod();
        this.search();
    },

    methods: {
        getToken() {
            PdfRendringService.getCognitoToken(this.clientId, this.clientSecret)
                .then(res => {
                    if (res.data) {
                        this.token = res.data.access_token
                    }
                }).catch(error => {
                    this.token = ""
                })
        },

        formatNumber(value) {
            // Split the input into the main number and the last digit
            let parts = value.split('-');
            let mainPart = parts[0];
            let lastDigit = parts[1];
            // Insert thousand separators
            let formattedMainPart = mainPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            // Combine the formatted part with the last digit
            return `${formattedMainPart}-${lastDigit}`;
        },
        isHighlighted(processId, fileName) {
            return this.FileList.some(
                f => f.processId === processId && f.fileName === fileName
            );
        },

        downloadPDF(index) {
            return downloadPDF(this.processDetailsInfo[index].comprobanteGenus);
        },

        downloadGenusPDF(intInstruccion, intSecuencia, intSeqRegistro) {
            PdfRendringService.getGenusPdfUrl(intInstruccion, intSecuencia, intSeqRegistro)
                .then(result => {
                    if (result.data) {
                        var url = result.data;
                        return downloadPDF(url);
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: "error",
                            text: 'No se ha encontrado ninguna URL pdf',
                        });
                    }
                })
                .catch((e) => {
                    this.$notify({
                        group: 'foo',
                        type: "error",
                        text: 'No se ha encontrado ninguna URL pdf',
                    });
                })
        },

        exportTodoCVS() {
            this.getToken();
            PdfRendringService.getExportTodoCVS(this.token, this.period)
                .then(res => {
                    if (res.data.includes('No Data Found To Generate CSV File')) {
                        this.$notify({
                            group: 'foo',
                            type: "error",
                            text: 'No se encontraron datos para generar el archivo CSV',
                        });
                    } else {
                        downloadCSV(res.data);
                    }

                }).catch(error => {

                    this.$notify({
                        group: 'foo',
                        type: "error",
                        text: 'no se encontraron datos'
                    })

                })
        },

        exportSelectionCVS() {
            this.getToken();

            let customerID = this.customerID ? this.customerID : "";
            let beneficiaryID = this.beneficiaryID ? this.beneficiaryID : "";

            PdfRendringService.getExportSelectionCVS(this.token, this.period, customerID, beneficiaryID)
                .then(res => {
                    if (res.data.includes('No Data Found To Generate CSV File')) {
                        this.$notify({
                            group: 'foo',
                            type: "error",
                            text: 'No se encontraron datos para generar el archivo CSV',
                        });
                    } else {
                        downloadCSV(res.data);
                    }

                }).catch(error => {

                    this.$notify({
                        group: 'foo',
                        type: "error",
                        text: 'no se encontraron datos'
                    })

                })
        },

        loadCurrentPeriod() {
            this.period = CurrentPeriod();
            this.setCurrentPeriodDate = true;
        },
        validatePeriod() {
            let required = false
            let period_errors = validatePeriodData(this.period, required);
            this.periodError = period_errors.periodError
            this.periodErrorMessage = period_errors.periodErrorMessage
        },

        handlePreviousPeriodData() {
            this.setCurrentPeriodDate = false;
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth(); // 0-based month

            if (month === 0) { // January
                month = 12;
                year -= 1;
            } else {
                month = month;
            }

            month = String(month).padStart(2, '0');
            this.period = `${year}${month}`;
            this.fetchProcessingSummary();
        },

        setCurrentPeriodData(res) {
            if (res) {
                //need to check if response value is null or not
                this.getByPeriodResponse = res.data;
                this.periodSummary = this.getByPeriodResponse[0].periodSummary;
                this.ProcessingSummary = this.getByPeriodResponse[0].standardProcessingSummary;
                this.ReprocessingSummary = this.getByPeriodResponse[0].reProcessingSummary;

                this.isStandardProcess = this.ProcessingSummary && this.ProcessingSummary.length > 0;

                if ((this.ProcessingSummary && this.ProcessingSummary.length > 0) ||
                    (this.ReprocessingSummary && this.ReprocessingSummary.length > 0)) {
                    this.isVisibleResumen = true;
                } else {
                    this.isVisibleResumen = false;
                }

                if (this.periodSummary && this.periodSummary.totalDeComprobantes == 0) {
                    this.isDataLoaded = false;
                    if (this.setCurrentPeriodDate) {
                        this.handlePreviousPeriodData()
                    }
                }
            }
        },

        fetchProcessingSummary() {
            PdfRendringService.getCognitoToken(this.clientId, this.clientSecret)
                .then(res => {
                    if (res.data) {
                        this.token = res.data.access_token

                        if (this.period && !this.customerID && !this.beneficiaryID) {
                            this.configthis = false;

                            PdfRendringService.getPeriodValue(this.token, this.period)
                                .then(res => {
                                    this.isLoader = false;
                                    this.setCurrentPeriodData(res);
                                }).catch((e) => {
                                    this.isLoader = false;
                                    this.isVisibleResumen = false;
                                    this.$notify({
                                        group: 'foo',
                                        type: "error",
                                        text: 'no se encontraron datos'
                                    })
                                })

                        }

                        if (this.period && this.customerID || this.beneficiaryID) {
                            let customerID = this.customerID ? this.customerID : "";
                            let beneficiaryID = this.beneficiaryID ? this.beneficiaryID : "";

                            PdfRendringService.getPeriodValue(this.token, this.period, customerID, beneficiaryID).then(res => {

                                this.getByPeriodResponse = res.data;
                                this.periodSummary = this.getByPeriodResponse[0].periodResponse[0].periodSummary;
                                this.ProcessingSummary = this.getByPeriodResponse[0].periodResponse[0].standardProcessingSummary;
                                this.ReprocessingSummary = this.getByPeriodResponse[0].periodResponse[0].reProcessingSummary;
                                this.processDetailsInfo = this.getByPeriodResponse[0].processDetails;
                                this.FileList = this.getByPeriodResponse[0].fileList;

                                this.isStandardProcess = this.ProcessingSummary && this.ProcessingSummary.length > 0; // standard process check
                                this.isProcessDetailsInfo = this.processDetailsInfo && this.processDetailsInfo.length > 0; //below section error check
                                this.isVisibleResumen = (this.ProcessingSummary && this.ProcessingSummary.length > 0) || (this.ReprocessingSummary && this.ReprocessingSummary.length > 0)
                                this.isDataLoaded = this.periodSummary.totalDeComprobantes == 0 ? false : true; // check if data is loaded or not
                                this.isVisible = true // below section visible check

                                if (
                                    (this.ProcessingSummary && this.ReprocessingSummary && this.periodSummary) ||
                                    (
                                        (!this.ProcessingSummary || this.ProcessingSummary.length === 0) &&
                                        (!this.ReprocessingSummary || this.ReprocessingSummary.length === 0) &&
                                        (
                                            this.isVisibleResumen === false ||
                                            this.isProcessDetailsInfo === false
                                        )
                                    )
                                ) {
                                    this.isLoader = false;
                                }
                            }).catch(error => {

                                this.isLoader = false;
                                this.isVisible = false;
                                this.isVisibleResumen = false;
                                this.$notify({
                                    group: 'foo',
                                    type: "error",

                                    text: 'no se encontraron datos'
                                });
                            })

                        } else {
                            this.isVisible = false;
                        }
                    }
                }).catch(error => {
                    this.token = ""
                })
        },

        search() {
            this.isLoader = true;
            this.isVisible = false;
            this.isVisibleResumen = false;
            this.periodError = false;
            this.customerIDError = false;
            this.beneficiaryIDError = false;
            this.isDataLoaded = true;
            this.rutFileName = [];
            this.FileList = [];
            if (this.period) this.validatePeriod();
            if (this.customerID) this.formatRut('customerID');
            if (this.beneficiaryID) this.formatRut('beneficiaryID');
            this.fetchProcessingSummary();
        },
        base64toBlob(b64Data, contentType = '', sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, {
                type: contentType
            });
            return blob;
        },

        viewAttachment(period, clientRut) {
            clientRut = clientRut.replace("-", "");
            PdfRendringService.getIPSServiceData(this.token, period, clientRut)
                .then((response) => {
                    var base64Data = response.data.resultado.liquidacion.base64;
                    const blobData = this.base64toBlob(base64Data, 'application/pdf');
                    if (window.navigator.msSaveOrOpenBlob) {
                        //IE11 & Edge
                        window.navigator.msSaveOrOpenBlob(blobData, response.data.resultado.liquidacion.nombreArchivo);
                    } else {
                        //Other browsers
                        var fileURL = window.URL.createObjectURL(blobData);
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', response.data.resultado.liquidacion.nombreArchivo);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }

                    this.message = "Archivo descargado exitosamente";
                })
                .catch((e) => {
                    this.$notify({
                        group: 'foo',
                        type: "error",
                        text: 'No se han encontrado datos',
                    });
                });
        },

        formatRut(field) {

            let value = this[field];
            value = value.replace(/[^\dkK]/g, '').toUpperCase();

            if (value.length === 0) {
                this[`${field}Error`] = false; //remove error if the input is empty
                this[field] = value;
                return;
            }
            if (value.length > 1) {
                const rut = value.slice(0, -1);
                const dv = value.slice(-1);
                this[field] = `${rut}-${dv}`;
                this[`${field}Error`] = !this.validateRUT(this[field]);
            } else {
                this[field] = value;
                this[`${field}Error`] = value.length === 1 ? !this.validateRUT(`${value.slice(0, -1)}-${value.slice(-1)}`) : true;
            }
        },
        validateRUT(rut) {
            if (!/^[0-9]+-[0-9kK]{1}$/.test(rut)) return false;

            const parts = rut.split('-');
            const dv = parts[1];
            const rutNumber = parts[0].replace(/\./g, ''); // Remove dots

            let T = rutNumber;
            let M = 0;
            let S = 1;

            for (; T; T = Math.floor(T / 10)) {
                S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
            }

            const calculatedDV = S ? S - 1 : 'k';

            return dv.toLowerCase() === calculatedDV.toString();
        },

    },
};
</script>

<style scoped>
.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    color: #dc3545;
}

.export-button {
    padding: 15px 0px;
}

.scroll-container {
    height: 300px;
    overflow-y: auto;
}

.reprocess-pb {
    border-radius: 0 0 0 0;
}
.progress.reprocess-pb {
    height: 50px;
    min-height: 50px;
}

.progress-bar {
    display: flex;
    min-height: 50px;
}
.progress{

    display: flex;
    min-height: 50px;


}
</style>



// WEBPACK FOOTER //
// src/components/Monitoring.vue